<template>
  <div class="slide-fish">
    <div class="t2">
      <a href="javascript:void(0);" id="bigimg" class="MagicZoom MagicThumb">
        <img :src="currentImage || product.coverPhoto" id="main_img" class="main_img" style="width:410px;height: 410px;">
      </a>
    </div>
    <div class="small-scroll">
      <a class="prev" href="javascript:void(0);" @click="scrollLeft"></a>
      <a class="next" href="javascript:void(0);" @click="scrollRight"></a>
      <div class="bd">
        <ul class="smallImg" id="imglist" ref="imageList">
          <li :class="{'on': currentIndex === -1}">
            <a rel="bigimg" :rev="product.coverPhoto" @click="changeImage(product.coverPhoto, -1)">
              <img :src="product.coverPhoto">
            </a>
          </li>
          <li v-for="(item, index) in product.carouselFigurePhotos" 
              :key="index" 
              :class="{'on': currentIndex === index}">
            <a rel="bigimg" :rev="item" @click="changeImage(item, index)">
              <img :src="item">
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductImageSlider',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentImage: null,
      currentIndex: -1
    }
  },
  methods: {
    changeImage(image, index) {
      this.currentImage = image
      this.currentIndex = index
    },
    scrollLeft() {
      this.$refs.imageList.scrollBy({
        left: -100,
        behavior: 'smooth'
      })
    },
    scrollRight() {
      this.$refs.imageList.scrollBy({
        left: 100,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.slide-fish {
  position: relative;
  width: 410px;
}
.t2 {
  margin-bottom: 10px;
}
.main_img {
  border: 1px solid #eee;
}
.small-scroll {
  position: relative;
  width: 410px;
  overflow: hidden;
}
.small-scroll .prev, 
.small-scroll .next {
  position: absolute;
  top: 50%;
  width: 20px;
  height: 40px;
  margin-top: -20px;
  background-color: rgba(0,0,0,0.3);
  color: #fff;
  text-align: center;
  line-height: 40px;
  z-index: 2;
  cursor: pointer;
}
.small-scroll .prev {
  left: 0;
}
.small-scroll .next {
  right: 0;
}
.bd {
  width: 370px;
  margin: 0 auto;
  overflow: hidden;
}
.smallImg {
  display: flex;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  transition: transform 0.3s ease;
}
.smallImg li {
  flex: 0 0 80px;
  margin-right: 10px;
  cursor: pointer;
}
.smallImg li.on {
  border: 2px solid #ff6700;
}
.smallImg li img {
  width: 100%;
  height: 80px;
  object-fit: cover;
}
</style>